import React from 'react';
import Helmet from 'react-helmet';
import '../../assets/scss/init.scss';
import { Navbar } from '../Navbar';
import styled from 'styled-components';

type IProps = {
  children: React.ReactElement;
};

export const PostLayout: React.FC<IProps> = ({ children }) => {
  return (
    <>
      <Navbar />
      <Container className="container">
        <Helmet defaultTitle="Blog by John Doe" />
        {children}
      </Container>
    </>
  );
};

const Container = styled.section`
  padding: 3rem 1.5rem;
`;

export default PostLayout;
